module.exports = __webpack_public_path__ + "img/Cutting_1200x800.d7cb2994.png";